// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_fsPH9","current":"index_current_G-PZv"};